module.exports = __webpack_public_path__ + "img/xml.5b68687d.svg";